import { render, staticRenderFns } from "./ServerValidation.vue?vue&type=template&id=0f666d92&scoped=true"
import script from "./ServerValidation.vue?vue&type=script&lang=js"
export * from "./ServerValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f666d92",
  null
  
)

export default component.exports